import React, { useState, useEffect, forwardRef } from "react";
import { useForm } from "react-hook-form";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import useFetch from "../../../../../hooks/useFetch";
import { FormControl, FormHelperText } from "@mui/material";
import FileUploader from "../../../../shares/fileUploader/FileUplaoder";
import ModalShell from "../../../../shares/dashboard/ModalShell";

const FORM_ID = "add-question-form";

const AddQuestion = forwardRef(({ close, get, edit }, ref) => {
  const [call, setCall] = useState({
    question_headline: "",
    question_category: "",
    question_answer: "",
    question_grade: "",
    question_book: "",
    question_time: "120",
    question_img: null,
    question_answer_img: null,
  });

  const newQuestion = useFetch({
    method: "POST",
    url: `management/questions/`,
    noHeader: false,
    trigger: false,
    data: call,
    caller: get,
  });

  const editQuestion = useFetch({
    method: "PATCH",
    url: `management/questions/${edit}/`,
    noHeader: false,
    trigger: false,
    data: call,
    caller: get,
  });

  const getQuestion = useFetch({
    method: "GET",
    url: `management/questions/${edit}/`,
    noHeader: false,
    trigger: edit ? true : false,
    setter: setCall,
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    values: call,
  });

  const onSubmit = (e) => {
    const formData = new FormData();
    if (typeof call.question_img == "object") {
      formData.append("question_img", call.question_img);
    }
    formData.append("question_headline", call.question_headline);
    formData.append("question_category", call.question_category);
    formData.append("question_book", call.question_book);
    formData.append("question_grade", call.question_grade);
    formData.append("question_answer", call.question_answer);
    if (typeof call.question_answer_img == "object") {
      formData.append("question_answer_img", call.question_answer_img);
    }
    formData.append("question_time", call.question_time);

    setCall(formData);
    if (edit) {
      editQuestion.reFetch();
    } else {
      newQuestion.reFetch();
    }
  };
  useEffect(() => {
    newQuestion.status === 201 && close();
    editQuestion.status === 200 && close();
  }, [newQuestion.status || editQuestion]);

  const submitting = newQuestion.loading || editQuestion.loading;

  return (
    <ModalShell
      ref={ref}
      close={close}
      title={edit ? "ویرایش سوال" : "سوال جدید"}
      subtitle="تصویر سوال و پاسخ، مبحث و گزینه صحیح"
      width="max-w-[56rem]"
      footer={
        <div className="flex justify-start">
          <button
            form={FORM_ID}
            type="submit"
            disabled={submitting}
            className="rounded-soft bg-primary px-2xl py-sm text-base text-white transition-colors duration-150 hover:bg-primary-hover active:bg-primary-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-60 motion-reduce:transition-none"
          >
            {submitting ? "در حال ثبت…" : "ثبت سوال"}
          </button>
        </div>
      }
    >
      <form
        id={FORM_ID}
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col gap-lg text-sm"
      >
        <div className="flex gap-x-6 w-full">
          <div className="flex items-end justify-center w-full">
            <FileUploader
              value={call.question_img}
              onChange={(file) =>
                setCall((prev) => ({ ...prev, question_img: file }))
              }
              label="بارگزاری سوال"
            />
          </div>
          <div className="flex items-end justify-center w-full">
            <FileUploader
              value={call.question_answer_img}
              onChange={(file) =>
                setCall((prev) => ({ ...prev, question_answer_img: file }))
              }
              label="بارگزاری پاسخ"
            />
          </div>
        </div>
        <div>
          <label htmlFor="question_headline" className="mb-2xs block text-sm text-ink-muted">
            عنوان
          </label>
          <TextField
            name="question_headline"
            value={call.question_headline}
            placeholder="عنوان"
            {...register("question_headline", {
              required: "عنوان را وارد کنید",
            })}
            error={!!errors.question_headline}
            helperText={
              errors.question_headline ? errors.question_headline.message : ""
            }
            onChange={(e) => {
              setCall({ ...call, question_headline: e.target.value });
            }}
            fullWidth
          />
        </div>

        <div>
          <label htmlFor="question_category" className="mb-2xs block text-sm text-ink-muted">
            مبحث
          </label>
          <FormControl
            error={errors.question_category ? true : false}
            fullWidth
          >
            <Select
              value={call.question_category}
              {...register("question_category", {
                required: "مبحث را وارد کنید",
              })}
              fullWidth
              onChange={(e) => {
                setCall({ ...call, question_category: e.target.value });
              }}
            >
              {lessons.map((lesson) => {
                return <MenuItem value={lesson}>{lesson}</MenuItem>;
              })}
            </Select>
            <FormHelperText>
              {errors?.question_category?.message}
            </FormHelperText>
          </FormControl>
        </div>
        <div>
          <label htmlFor="question_grade" className="mb-2xs block text-sm text-ink-muted">
            مقطع
          </label>
          <FormControl error={errors.question_grade ? true : false} fullWidth>
            <Select
              value={call.question_grade}
              {...register("question_grade", {
                required: "مقطع را وارد کنید",
              })}
              fullWidth
              onChange={(e) => {
                setCall({ ...call, question_grade: e.target.value });
              }}
            >
              {grade.map((grade) => {
                return <MenuItem value={grade}>{grade}</MenuItem>;
              })}
            </Select>
            <FormHelperText>{errors?.question_grade?.message}</FormHelperText>
          </FormControl>
        </div>

        <div>
          <label htmlFor="question_book" className="mb-2xs block text-sm text-ink-muted">
            کتاب
          </label>
          <TextField
            name="question_book"
            value={call.question_book}
            placeholder="کتاب"
            {...register("question_book", {
              required: "کتاب را وارد کنید",
            })}
            error={!!errors.question_book}
            helperText={
              errors.question_book ? errors.question_book.message : ""
            }
            onChange={(e) => {
              setCall({ ...call, question_book: e.target.value });
            }}
            fullWidth
          />
        </div>

        <div>
          <label htmlFor="question_answer" className="mb-2xs block text-sm text-ink-muted">
            پاسخ صحیح
          </label>
          <FormControl error={errors.question_answer ? true : false} fullWidth>
            <Select
              value={call.question_answer}
              {...register("question_answer", {
                required: "پاسخ را وارد کنید",
              })}
              fullWidth
              onChange={(e) => {
                setCall({ ...call, question_answer: e.target.value });
              }}
            >
              <MenuItem value="1">1</MenuItem>
              <MenuItem value="2">2</MenuItem>
              <MenuItem value="3">3</MenuItem>
              <MenuItem value="4">4</MenuItem>
            </Select>
            <FormHelperText>{errors?.question_answer?.message}</FormHelperText>
          </FormControl>
        </div>
        <div>
          <label htmlFor="question_time" className="mb-2xs block text-sm text-ink-muted">
            زمان سوال
          </label>
          <TextField
            type={"number"}
            name="question_time"
            value={call.question_time}
            placeholder="زمان سوال"
            {...register("question_time", {
              required: "زمان سوال را وارد کنید",
            })}
            error={!!errors.question_time}
            helperText={
              errors.question_time ? errors.question_time.message : ""
            }
            onChange={(e) => {
              setCall({ ...call, question_time: e.target.value });
            }}
            fullWidth
          />
        </div>
      </form>
    </ModalShell>
  );
});

export default AddQuestion;

const digits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

const lessons = [
  "توابع و خواص آن ها",
  "معادله درجه دوم",
  "الگو و دنباله",
  "مثلثات",
  "توان های گویا و عبارات جبری",
  "مرور توابع و خواص آن ها",
  "آنالیز",
  "احتمالات",
  "هندسه مختصاتی",
  "معادلات و نامعادلات گویا و گنگ",
  "قدر مطلق",
  "براکت",
  "هندسه",
  "توابع نمایی و لگاریتم",
  "حد",
  "پیوستگی",
  "بخش پذیری",
  "مشتق",
  "کاربرد مشتق",
  "مجانب ها",
  "مقاطع مخروطی",
];
const grade = ["دهم", "یازدهم", "دوازدهم"];
